import { Component } from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {FeedbackFormComponent} from "./feedback-form/feedback-form.component";

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  standalone: true,
  imports: [
    MatIcon,
    FeedbackFormComponent
  ],
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent {

}
